module.exports = __webpack_public_path__ + "static/media/sample_lmtruckdetails.ee87cc99.csv";